import React from "react";
import { MethodBadge } from "./Methodbadge";

interface EndpointHeaderProps {
  method: string;
  url: string;
}

export const EndpointHeader: React.FC<EndpointHeaderProps> = ({ method, url }) => (
  <div className="flex items-center gap-3 border border-white/[0.08]
    bg-white/[0.04] backdrop-blur-[6px] rounded-xl px-4 py-3 mt-4 font-mono text-sm">
    <MethodBadge method={method} />
    <span className="text-web-primary">{url}</span>
  </div>
);